<!--
*****************************************************************************
*File : dpu-live-view.vue
*Module : Dashboard Frontend
*Purpose : Display DPs data in the table format
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-container
    id="data-tables"
    fluid>
  <v-row no-gutters>

    <!-- ************************************************ UNLOADING ZONE DPU ******************************************** -->
    <v-col 
        class="px-3"
        cols="12"
        sm="6"
        md="6">
        <base-material-card
            color="green"
            icon="mdi-table"
            inline
            class="px-5 py-3">

            <template v-slot:after-heading>
                <div class="display-1 font-weight-bold">
               CAMERAS 
                </div>
            </template>

            <v-divider class="mt-3" />

            <v-data-table
		        dense
                hide-default-footer
                disable-pagination
                :headers="dpu1"
                :items="dpu1_valueCpy">

                <template v-slot:[`item.id`]="{ item }">
                    <v-text-field v-if="(item.dpu1_error) != 'up'" class="font-weight-bold text-center warning--text text-uppercase" v-text="(item.id)"/>
                    <v-text-field v-else class="text-uppercase success--text text-center" v-text="(item.id)"/>
                </template>
                <!-- <template v-slot:[`item.dpu_axle_in`]="{ item }">
                    <v-text-field v-if="(item.dpu1_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_in)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_in)"/>
                </template>
                <template v-slot:[`item.dpu_axle_out`]="{ item }">
                    <v-text-field v-if="(item.dpu1_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_out)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_out)"/>
                </template> -->
                <template v-slot:[`item.dpu1_error`]="{ item }">
                    <v-text-field v-if="(item.dpu1_error) != 'up'" class="font-weight-bold text-center warning--text text-uppercase" v-text="(item.dpu1_error)"/>
                    <v-text-field v-else class="text-uppercase success--text text-center" v-text="(item.dpu1_error)"/>
                </template>

            </v-data-table>
            <v-card style="border-top-left-radius: 0; border-top-right-radius: 0; box-shadow: none;">
                <v-card-text>
                    <div style="position: absolute; top: -10px" class="body-1 font-weight-light">
                         <v-icon class="mdi-18px roundedIcon success" style="color: white">mdi-clock</v-icon> Last Updated Time: {{this.dpu1_lastUpdated}}
                    </div>
                </v-card-text>
            </v-card>
        </base-material-card>
    </v-col>

    <!-- ************************************************ ENTRY-EXIT ZONE DPU ******************************************** -->
    <v-col 
        class="px-3"
        cols="12"
        sm="6"
        md="6">
        <base-material-card
            color="green"
            icon="mdi-table"
            inline
            class="px-5 py-3">

            <template v-slot:after-heading>
                <div class="display-1 font-weight-bold">
                TRIGGERING SENSORS
                </div>
            </template>

            <v-divider class="mt-3" />

            <v-data-table
                dense
                hide-default-footer
                disable-pagination
                :headers="dpu2"
                :items="dpu2_valueCpy">

                <template v-slot:[`item.id`]="{ item }">
                    <v-text-field v-if="(item.dpu2_error) != 'up'" class="font-weight-bold text-center warning--text text-uppercase" v-text="(item.id)"/>
                    <v-text-field v-else class="text-uppercase text-center" v-text="(item.id)"/>
                </template>
                <!-- <template v-slot:[`item.dpu_axle_in`]="{ item }">
                    <v-text-field v-if="(item.dpu2_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_in)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_in)"/>
                </template>
                <template v-slot:[`item.dpu_axle_out`]="{ item }">
                    <v-text-field v-if="(item.dpu2_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_out)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_out)"/>
                </template> -->
                 <template v-slot:[`item.dpu2_error`]="{ item }">
                    <v-text-field v-if="(item.dpu2_error) != 'up'" class="font-weight-bold text-center warning--text text-uppercase" v-text="(item.dpu2_error)"/>
                    <v-text-field v-else class="text-uppercase text-center" v-text="(item.dpu2_error)"/>
                </template>
            </v-data-table>
            <v-card style="border-top-left-radius: 0; border-top-right-radius: 0; box-shadow: none;">
                <v-card-text>
                    <div style="position: absolute; top: -10px" class="body-1 font-weight-light">
                         <v-icon class="mdi-18px roundedIcon success" style="color: white">mdi-clock</v-icon> Last Updated Time: {{this.dpu2_lastUpdated}}
                    </div>
                </v-card-text>
            </v-card>
        </base-material-card>
    </v-col>

    <!-- ************************************************ DPU_03 ******************************************************** -->
    <!-- <v-col 
        class="px-3"
        cols="12"
        sm="6"
        md="6">
        <base-material-card
            color="green"
            icon="mdi-table"
            inline
            class="px-5 py-3">
            <template v-slot:after-heading>
                <div class="display-1 font-weight-bold">
                DPU3
                </div>
            </template>

            <v-divider class="mt-3" />
            
	    <v-data-table
                dense
                hide-default-footer
                disable-pagination
                :headers="dpu3"
                :items="dpu3_value">

                <template v-slot:[`item.id`]="{ item }">
                    <v-text-field v-if="(item.dpu3_error) > 0" class=" text-center warning--text" v-text="(item.id)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.id)"/>
                </template>
                <template v-slot:[`item.dpu_axle_in`]="{ item }">
                    <v-text-field v-if="(item.dpu3_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_in)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_in)"/>
                </template>
                <template v-slot:[`item.dpu_axle_out`]="{ item }">
                    <v-text-field v-if="(item.dpu3_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_out)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_out)"/>
                </template>
                 <template v-slot:[`item.dpu3_error`]="{ item }">
                    <v-text-field v-if="(item.dpu3_error) > 0" class=" text-center warning--text" v-text="(item.dpu3_error)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu3_error)"/>
                </template>
            </v-data-table>
            <v-card style="border-top-left-radius: 0; border-top-right-radius: 0; box-shadow: none;">
                <v-card-text>
                    <div style="position: absolute; top: -10px" class="body-1 font-weight-light">
                         <v-icon class="mdi-18px roundedIcon success" style="color: white">mdi-clock</v-icon> Last Updated Time: {{this.dpu3_lastUpdated}}
                    </div>
                </v-card-text>
            </v-card>
        </base-material-card>
    </v-col> -->
    <!-- ************************************************ DPU_04 ******************************************************** -->
    <!-- <v-col 
        class="px-3"
        cols="12"
        sm="6"
        md="6">
        <base-material-card
            color="green"
            icon="mdi-table"
            inline
            class="px-5 py-3">
            <template v-slot:after-heading>
                <div class="display-1 font-weight-bold">
                DPU4
                </div>
            </template>

            <v-divider class="mt-3" />
              <v-data-table
                dense
                hide-default-footer
                disable-pagination
                :headers="dpu4"
                :items="dpu4_value">
                <template v-slot:[`item.id`]="{ item }">
                    <v-text-field v-if="(item.dpu4_error) > 0" class=" text-center warning--text" v-text="(item.id)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.id)"/>
                </template>
                <template v-slot:[`item.dpu_axle_in`]="{ item }">
                    <v-text-field v-if="(item.dpu4_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_in)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_in)"/>
                </template>
                <template v-slot:[`item.dpu_axle_out`]="{ item }">
                    <v-text-field v-if="(item.dpu4_error) > 0" class=" text-center warning--text" v-text="(item.dpu_axle_out)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu_axle_out)"/>
                </template>
                 <template v-slot:[`item.dpu4_error`]="{ item }">
                    <v-text-field v-if="(item.dpu4_error) > 0" class=" text-center warning--text" v-text="(item.dpu4_error)"/>
                    <v-text-field v-else class=" text-center" v-text="(item.dpu4_error)"/>
                </template>
            </v-data-table>
            <v-card style="border-top-left-radius: 0; border-top-right-radius: 0; box-shadow: none;">
                <v-card-text>
                    <div style="position: absolute; top: -10px" class="body-1 font-weight-light">
                         <v-icon class="mdi-18px roundedIcon success" style="color: white">mdi-clock</v-icon> Last Updated Time: {{this.dpu4_lastUpdated}}
                    </div>
                </v-card-text>
            </v-card>
        </base-material-card>
    </v-col> -->
  </v-row>  
  </v-container>
</template>


<script>
import axios from 'axios';
import Api from '@/views/service/api'
import { VDaterange } from "vuetify-daterange-picker"
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css";
import dpuLiveView from './dpu-live-view';
import store from '../../store'
import "@/assets/mqtt/mqttws31.min.js"
import globalConf from '../../../globalConf'
import Vue from 'vue';
import { indexOf } from 'lodash';

export default {
    
  name: "dataTable",
    components: { VDaterange },
  data() {
    return {
        mqtt : '',
        reconnectTimeout : 0,
        host : globalConf.mqttBrokerHost,
        port : globalConf.websocketPort,
        dpu1_value :[],
        dpu2_value:[],
        dpu3_value:[],
        dpu4_value:[],
        dpu1Data:{},

        message :[],
        breakLoop:false,
        DPUArr:[],
        dpu1_valueCpy :[],
        dpu2_valueCpy:[],
        dpu3_valueCpy:[],
        dpu4_valueCpy:[],

        dpu1_lastUpdated:'',
        dpu2_lastUpdated:'',
        dpu3_lastUpdated:'',
        dpu4_lastUpdated:'',

      dpu1: [
        { text: 'Name', value: 'id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Axles In', value: 'dpu_axle_in', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Axles Out', value: 'dpu_axle_out', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Current Status', value: 'dpu1_error', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      dpu2: [
        { text: 'Name', value: 'id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Axles In', value: 'dpu_axle_in', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Axles Out', value: 'dpu_axle_out', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Current Status', value: 'dpu2_error', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
    //   dpu3: [
    //     { text: 'ID', value: 'id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //     { text: 'Axles In', value: 'dpu_axle_in', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //     { text: 'Axles Out', value: 'dpu_axle_out', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //     { text: 'Error Code', value: 'dpu3_error', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //   ],
    //   dpu4: [
    //     { text: 'ID', value: 'id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //     { text: 'Axles In', value: 'dpu_axle_in', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //     { text: 'Axles Out', value: 'dpu_axle_out', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //     { text: 'Error Code', value: 'dpu4_error', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    //   ]
    }
  },

  mounted() {

   this.MQTTconnect();
     
  },
  methods :{
    onMessageArrived(msg){
    if( msg.destinationName == "site_01/dpu_01/health_info") {   
      console.log("msg!: ", JSON.parse(msg.payloadString));
      var acp_dp_info = JSON.parse(msg.payloadString);
      var sensors_id = ["interrogator_link", "T1", "T2", "T3", "T4"];
      var name = ["Interrogator", "T1", "T2", "T3", "T4"];
        this.dpu2_valueCpy = [];

        for (const item in (sensors_id)) {
            if(acp_dp_info['dpu_id']=="DPU_01"){

                this.dpu2_valueCpy.push({
                    id : name[item],
                    // dpu_axle_in :acp_dp_info["dps"][i][j]['consolidated']['in_axles'],
                    // dpu_axle_out :acp_dp_info["dps"][i][j]['consolidated']['out_axles'],
                    dpu2_error : acp_dp_info[sensors_id[item]]
                })
                let epochToTime = new Date(acp_dp_info['ts']*1000).toString()
                this.dpu2_lastUpdated = epochToTime = epochToTime.split(' ', 5).join(' ');
            }

            console.log("cpy, ", this.dpu2_valueCpy);
        }
    } 

    else if(msg.destinationName == "site_01/as_01/health_info") {
        console.log("msg!: ", JSON.parse(msg.payloadString));
      var mvis_health_info = JSON.parse(msg.payloadString);
      var sensors_id = ["llm", "rlm", "lum", "rum", "linescan", "mvis_server", "fwild_server"];
      var name = ["Left Lower Camera", "Right Lower Camera", "Left Upper Camera", "Right Upper Camera", "Linescan", "MVIS Server", "FWILD Server"];
        this.dpu1_valueCpy = [];

        for (const item in (sensors_id)) {
            // if(mvis_health_info['dpu_id']=="DPU_01"){

                this.dpu1_valueCpy.push({
                    id : name[item],
                    // dpu_axle_in :acp_dp_info["dps"][i][j]['consolidated']['in_axles'],
                    // dpu_axle_out :acp_dp_info["dps"][i][j]['consolidated']['out_axles'],
                    dpu1_error : mvis_health_info[sensors_id[item]]
                })
                let epochToTime = new Date(mvis_health_info['ts']*1000).toString()
                this.dpu1_lastUpdated = epochToTime = epochToTime.split(' ', 5).join(' ');
            // }

            console.log("1 cpy, ", this.dpu1_valueCpy);
        }
    }
            //##### DISPLAY #####//

            // if(item < sensors_id.length) {
            //     this.dpu2_value=[]
            //     var uniqueArray = removeDuplicates(this.dpu2_valueCpy, "id");
                
                        
			// function removeDuplicates(originalArray, prop) {
            //     var newArray = [];
            //     var lookupObject  = {};

            //     for(var i in originalArray) {
            //         lookupObject[originalArray[i][prop]] = originalArray[i];
            //     }

            //     for(i in lookupObject) {
            //         newArray.push(lookupObject[i]);
            //     }
            //     return newArray;
            // }
            //     this.dpu2_value = uniqueArray
            //     let epochToTime = new Date(acp_dp_info['ts']*1000).toString()
            //     this.dpu2_lastUpdated =epochToTime=epochToTime.split(' ', 5).join(' ');
            //     this.dpu2_valueCpy = []
            // }
            // console.log("dpu2: ", this.dpu2_value);
            
            
        
                
                // for(var i in acp_dp_info["dps"] ){
                    
                //     for(var j in acp_dp_info["dps"][i]){
       
                //             this.dpu1_valueCpy.push({
                //                 id :acp_dp_info["dps"][i][j]['dp_id'],
                //                 dpu_axle_in :acp_dp_info["dps"][i][j]['consolidated']['in_axles'],
                //                 dpu_axle_out :acp_dp_info["dps"][i][j]['consolidated']['out_axles'],
                //                 dpu1_error :acp_dp_info["dps"][i][j]['consolidated']['error_code']
                //             })
                           
                //             index++;
                //         }                   
                // }  
		// if(i ==acp_dp_info["dps"].length-1 ||i ==acp_dp_info["dps"].length){
        //                 this.dpu1_value=[]
        //                 var uniqueArray = removeDuplicates(this.dpu1_valueCpy, "id");
                        
		// 	function removeDuplicates(originalArray, prop) {
        //                     var newArray = [];
        //                     var lookupObject  = {};

        //                     for(var i in originalArray) {
        //                         lookupObject[originalArray[i][prop]] = originalArray[i];
        //                     }

        //                     for(i in lookupObject) {
        //                         newArray.push(lookupObject[i]);
        //                     }
        //                     return newArray;
        //                 }
        //                 this.dpu1_value = uniqueArray
        //                 let epochToTime = new Date(acp_dp_info['ts']*1000).toString()
        //                 this.dpu1_lastUpdated =epochToTime=epochToTime.split(' ', 5).join(' ');
        //                 this.dpu1_valueCpy =[]

        //         }

        //     }
            
	    // if(acp_dp_info['dpu_id']=="DPU_02"){
                
        //         let index=0;
        //         for(var i in acp_dp_info["dps"] ){
                    
        //             for(var j in acp_dp_info["dps"][i]){
                       
        //                     this.dpu2_valueCpy.push({
        //                         id :acp_dp_info["dps"][i][j]['dp_id'],
        //                         dpu_axle_in :acp_dp_info["dps"][i][j]['consolidated']['in_axles'],
        //                         dpu2_error :acp_dp_info["dps"][i][j]['consolidated']['error_code'],
        //                         dpu_axle_out :acp_dp_info["dps"][i][j]['consolidated']['out_axles'],
        //                     })
                           
        //                     index++;
        //                 } 
                  
                  
        //         }  

		// if(i ==acp_dp_info["dps"].length-1 ||i ==acp_dp_info["dps"].length){
        //                 this.dpu2_value=[]
        //                 let uniqueArray = removeDuplicates(this.dpu2_valueCpy, "id");
                        
        //                 function removeDuplicates(originalArray, prop) {
        //                     var newArray = [];
        //                     var lookupObject  = {};

        //                     for(var i in originalArray) {
        //                         lookupObject[originalArray[i][prop]] = originalArray[i];
        //                     }

        //                     for(i in lookupObject) {
        //                         newArray.push(lookupObject[i]);
        //                     }
        //                     return newArray;
        //                 }
        //                 this.dpu2_value = uniqueArray
        //                 let epochToTime = new Date(acp_dp_info['ts']*1000).toString()
        //                 this.dpu2_lastUpdated =epochToTime=epochToTime.split(' ', 5).join(' ');
        //                 this.dpu2_valueCpy =[]
                        
        //             }
        //     }

        //     if(acp_dp_info['dpu_id']=="DPU_03"){
                
        //         let index=0;
        //         for(var i in acp_dp_info["dps"] ){
                    
        //             for(var j in acp_dp_info["dps"][i]){
                       
        //                     this.dpu3_valueCpy.push({
        //                         id :acp_dp_info["dps"][i][j]['dp_id'],
        //                         dpu_axle_in :acp_dp_info["dps"][i][j]['consolidated']['in_axles'],
        //                         dpu_axle_out :acp_dp_info["dps"][i][j]['consolidated']['out_axles'],
        //                         dpu3_error :acp_dp_info["dps"][i][j]['consolidated']['error_code']
        //                     })
                           
        //                     index++;
        //                 } 
                  
                  
        //         }  
		
		// if(i ==acp_dp_info["dps"].length-1 ||i ==acp_dp_info["dps"].length){
        //                 this.dpu3_value=[]
        //                 let uniqueArray = removeDuplicates(this.dpu3_valueCpy, "id");
                        
        //                 function removeDuplicates(originalArray, prop) {
        //                     var newArray = [];
        //                     var lookupObject  = {};

        //                     for(var i in originalArray) {
        //                         lookupObject[originalArray[i][prop]] = originalArray[i];
        //                     }

        //                     for(i in lookupObject) {
        //                         newArray.push(lookupObject[i]);
        //                     }
        //                     return newArray;
        //                 }
        //                 this.dpu3_value = uniqueArray
        //                 let epochToTime = new Date(acp_dp_info['ts']*1000)
        //                 let subTime =new Date(( Date.parse(epochToTime)) -(19800000)).toString()
        //                 this.dpu3_lastUpdated =epochToTime=subTime.split(' ', 5).join(' ');
        //                 this.dpu3_valueCpy =[]
        //          }

        //     }
            
	    // if(acp_dp_info['dpu_id']=="DPU_04"){
            
        //         let index=0;
        //         for(var i in acp_dp_info["dps"] ){
                    
        //             for(var j in acp_dp_info["dps"][i]){
                       
        //                     this.dpu4_valueCpy.push({
        //                         id :acp_dp_info["dps"][i][j]['dp_id'],
        //                         dpu_axle_in :acp_dp_info["dps"][i][j]['consolidated']['in_axles'],
        //                         dpu_axle_out :acp_dp_info["dps"][i][j]['consolidated']['out_axles'],
        //                         dpu4_error :acp_dp_info["dps"][i][j]['consolidated']['error_code']
        //                     })
                           
        //                     index++;
        //                 } 
                  
                  
        //         }  
		
		// if(i == acp_dp_info["dps"].length-1 || i == acp_dp_info["dps"].length){
        //                	this.dpu4_value=[]
        //                 let uniqueArray = removeDuplicates(this.dpu4_valueCpy, "id");
                       
        //                 function removeDuplicates(originalArray, prop) {
        //                     var newArray = [];
        //                     var lookupObject  = {};

        //                     for(var i in originalArray) {
        //                         lookupObject[originalArray[i][prop]] = originalArray[i];
        //                     }

        //                     for(i in lookupObject) {
        //                         newArray.push(lookupObject[i]);
        //                     }
        //                     return newArray;
        //                 }
        //                 this.dpu4_value = uniqueArray
        //                 let epochToTime = new Date(acp_dp_info['ts']*1000)
        //                 let subTime =new Date(( Date.parse(epochToTime)) -(19800000)).toString()
        //                 this.dpu4_lastUpdated =epochToTime=subTime.split(' ', 5).join(' ');
        //                 this.dpu4_valueCpy =[]

        //             }
            // }
        // }  
    
  },
  
  MQTTconnect(){
    console.log("connecting to "+ this.host + ":" + this.port);
    
    var clientid = new Date().getTime();
    var self = this;

    this.mqtt = new Paho.MQTT.Client(this.host, this.port,clientid.toString());
    var options ={
      timeout:3,
      userName: globalConf.mqttUsername,
      password: globalConf.mqttPassword,
      onSuccess: () => { 
        console.log("live-view connected");
        self.mqtt.subscribe("site_01/dpu_01/health_info")
        self.mqtt.subscribe("site_01/as_01/health_info")
      },
    };

    this.mqtt.onMessageArrived = this.onMessageArrived
    this.mqtt.connect(options,  {keepalive: 0, clean: true, clientid:clientid, reconnect :true});  
    
  },
  },

  destroyed() {
    console.log("dpu-live-view-mqtt-destroyed");
  
	this.mqtt.disconnect();
    //dpuLiveView.destroy();
  },
 
};
</script>
